export const SET_SORT = 'SET_SORT';
export const RESET_SORT = 'RESET_SORT';

export interface SortState {
  key: string,
  value: 'asc' | 'desc',
}
